"use client";

import { memo } from "react";
import { Box, Text, Table } from "@chakra-ui/react";
import type { AtsJobDetails } from "../types";
import { SectionTitle } from "./SectionTitle";

export interface SkillsSectionProps {
  skills: AtsJobDetails["skills"];
}

export const SkillsSection = memo<SkillsSectionProps>(({ skills }) => {
  if (!skills || skills.length === 0) return null;

  return (
    <Box as="section" aria-label="Skills" mb={6}>
      <SectionTitle title="Skills" />
      <Table.Root variant="outline" size="sm" rounded="xl">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader width="80%">Skill</Table.ColumnHeader>
            <Table.ColumnHeader width="20%">Level</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {skills.map((skill, index) => (
            <Table.Row key={`${skill.name}-${index}`}>
              <Table.Cell width="80%">
                <Text textStyle="sm" color="neutral.700" lineHeight="1.6">
                  {skill.name}
                </Text>
                <Text textStyle="xs" color="neutral.500" fontWeight="medium">
                  {skill.reason || "N/A"}
                </Text>
              </Table.Cell>
              <Table.Cell width="20%" textAlign="left">
                <Text textStyle="sm" color="neutral.500" lineHeight="1.6">
                  {skill.level}
                </Text>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
});
SkillsSection.displayName = "SkillsSection";
